import { HelpEntry } from '~/routes/keyboard-help/context';

// Skip intro and skip outro are the two moments mid-song where the television puts up its own
// overlay and the phone is still the microphone. The space the arrow pad would take goes to saying
// so, rather than to two buttons floating in a screen of nothing. Matched on the screen's own glyph
// rather than its title, which is copy.
export const mirrorDrawsItsOwnMicCircle = (keyboard: HelpEntry | undefined, songStarted: boolean) =>
  songStarted && keyboard?.mode === 'mirror' && keyboard?.icon === 'play';
